
interface DealsStatsProps {
  displayedCount: number;
  totalCount: number;
}

export const DealsStats = ({ displayedCount, totalCount }: DealsStatsProps) => {
  return (
    <div className="text-sm text-gray-600">
      {displayedCount} van {totalCount} {totalCount === 1 ? 'deal' : 'deals'} getoond
    </div>
  );
};
